export function addCurrent(techinicalteamuser) {
    return {
        type: 'ADD_CURRENT',
        techinicalteamuser,
    }
}
